import type {EmbeddedToSheetConfig} from './types'

type ShellAnimationStyle = EmbeddedToSheetConfig['animationStyle']

export const SubmitIconSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m5 12 7-7 7 7"/><path d="M12 19V5"/></svg>`
export const CloseIconSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>`

const AnimationGradients: Record<Exclude<ShellAnimationStyle, 'none'>, readonly string[]> = {
  ember: ['#B784E5', '#F3AC9A', '#F6CB95', '#FFFFFF'],
  nebula: ['#84D8E5', '#C955ED', '#F695A0', '#FFFFFF'],
  beam: ['#8A8A8A', '#B9B9B9', '#EDEDED', '#FFFFFF'],
}

export function applyThemeVariables(root: HTMLElement, theme: Record<string, string>): void {
  for (const [key, value] of Object.entries(theme)) {
    if (key.startsWith('--')) {
      root.style.setProperty(key, value)
    }
  }
}

export function applyPanelCornerRadius(root: HTMLElement, radius: string | undefined): void {
  // Only square themes override the panel's existing desktop/mobile corner styles.
  root.style.setProperty('--anagram-panel-radius', parseFloat(radius ?? '') === 0 ? '0px' : '')
}

export function applyShellInputAnimation(wrapper: HTMLElement, animationStyle: ShellAnimationStyle): void {
  if (animationStyle === 'none') {
    return
  }

  wrapper.classList.add('has-animation')
  const gradients = AnimationGradients[animationStyle]
  for (const [index, gradient] of gradients.entries()) {
    wrapper.style.setProperty(`--shine-color-${index + 1}`, gradient)
  }
}
